import { datadogRum } from '@datadog/browser-rum-slim';

const { NODE_ENV } = process.env;

let idCounter = 0;

const mark = (name: string) => {
  const { performance } = window;
  performance.mark(name);
};

const measure = (name: string, startMark: string, endMark: string) => {
  const { performance } = window;
  performance.measure(name, startMark, endMark);
  performance.clearMarks(startMark);
  performance.clearMarks(endMark);

  const entries = performance.getEntriesByName(name);

  return entries[entries.length - 1];
};

export class PerformanceTimer {
  // eslint-disable-next-line no-plusplus
  private id = idCounter++;

  private tracked: boolean = false;

  private constructor(
    public name: string,
    public initialData: any
  ) {}

  static createAndStart(name: string, initialData?: Record<string, any>) {
    const timer = new PerformanceTimer(name, initialData);
    timer.start();
    return timer;
  }

  private start() {
    mark(`${this.name}-start-${this.id}`);
  }

  private end() {
    mark(`${this.name}-end-${this.id}`);
    return measure(this.name, `${this.name}-start-${this.id}`, `${this.name}-end-${this.id}`);
  }

  success(data?: Record<string, any>) {
    if (this.tracked) {
      return;
    }
    const entry = this.end();
    this.track({ duration: entry.duration, success: true, ...data });
  }

  failure(error: Error, data?: Record<string, any>) {
    if (this.tracked) {
      return;
    }
    const entry = this.end();
    this.track({
      duration: entry.duration,
      success: false,
      ...(error && { errorMessage: error.message }),
      ...data
    });
  }

  private track(data: any) {
    const dataCombined = {
      ...this.initialData,
      ...data
    };

    if (NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.info('track', this.name, dataCombined);
    }

    datadogRum.addAction(this.name, dataCombined);

    this.tracked = true;
  }
}
